import React from 'react';

const ButtonForm = ({ buttonConfig }) => {
    const { leftButtons = [], rightButtons = [], fncButtons = [] } = buttonConfig;

    return (
        <div className="button-toolbar-container d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2 mt-2">
            <div>
                {fncButtons.length > 0 && (
                    <div className="btn-group me-2">
                        {fncButtons.map((button) => (
                            <button
                                key={button.id}
                                type="button"
                                className={`btn btn-sm ${button.className} me-1`}
                                onClick={button.onClick}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
            <div className="btn-toolbar mb-2 mb-md-1 mt-1">
                {leftButtons.length > 0 && (
                    <div className="btn-group me-2">
                        {leftButtons.map((button) => (
                            <button
                                key={button.id}
                                type="button"
                                className={`btn btn-sm ${button.className} me-1`}
                                onClick={button.onClick}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>
                )}
                {rightButtons.length > 0 && (
                    <div className="btn-group">
                        {rightButtons.map((button) => (
                            <button
                                key={button.id}
                                type="button"
                                className={`btn btn-sm ${button.className}`}
                                onClick={button.onClick}
                            >
                                {button.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ButtonForm;